<template>
  <div class>
    <div class="right_content">
      <div class="change_inform">
        <div class="title">技术澄清</div>
      </div>
      <div class="right_out">
        <div style="padding: 5px; margin: 10px">
          <span>项目名称</span>
          <el-input type="text" class="searchinput" v-model="Query.projectName" size="mini"></el-input>
          <span>状态</span>
          <el-select class="searchinput" v-model="Query.Status" placeholder="请选择">
            <el-option v-for="item in ClarifyStatus" :key="item.Value" :label="item.Text" :value="item.Value"> </el-option>
          </el-select>
          <el-button id="search" @click="fnGetData">搜索</el-button>
        </div>
        <el-table class="table_wrap1" :data="tableData" style="width: 100%">
          <el-table-column type="expand" style="padding: 0">
            <template slot-scope="props">
              <table class="statistics_table">
                <tr>
                  <th class="th1">包组信息</th>
                  <th class="th1" style="width: 120px">状态</th>
                  <th class="th1" style="width: 200px">回执上传截止时间</th>
                  <th class="th1" style="width: 240px">操作</th>
                </tr>
                <tr v-for="(item, index) in props.row.schemeList" :key="index">
                  <td class="td1">{{ item.ProjectName }}-{{ item.GroupName }}</td>
                  <td class="td1">
                    <div>
                      <span>{{ item.Status }}</span>
                    </div>
                  </td>
                  <td class="td1">{{ item.ComfirnDeadline }}</td>
                  <td class="td1">
                    <div class="btn_wrap">
                      <el-button class="btn" @click="fnReply(item.ClarifyId)" type="text" size="small" v-if="item.CanReply">回复</el-button>
                    </div>
                  </td>
                </tr>
              </table>
            </template>
          </el-table-column>
          <el-table-column prop="SchemeCode" label="采购编号"></el-table-column>
          <el-table-column prop="ProjectName" label="项目名称"></el-table-column>
          <el-table-column prop="PurchaseMethod" label="采购方式"></el-table-column>
          <el-table-column prop="ProjectType" label="项目类型"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'aboutUs',
  components: {},
  data() {
    return {
      ClarifyStatus: [],
      Query: {},
      tableData: []
    }
  },
  created() {},
  computed: {},
  mounted() {
    this.AddListener()
    this.fnInit()
    this.fnGetData()
  },
  methods: {
    fnInit() {
      //获取登录供应商基础信息
      // this.getRequest("SupplierLogin/MemberCenterData")
      //   .then(res => {
      //     if (res.data.errcode == 0) {
      //       this.loginInfos = res.data.logindata;
      //     } else {
      //       this.$message.error(res.data.errmsg);
      //     }
      //   })
      //   .catch(function(error) {
      //     console.log(error);
      //   });

      this.getRequest('Purchase/GetClarifyQuery')
        .then((res) => {
          if (res.data.errcode == 0) {
            this.ClarifyStatus = res.data.ClarifyStatus
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    AddListener() {
      //监听（刷新列表）
      window.addEventListener('storage', (e) => {
        if (e.key == 'ClarifyList') {
          this.fnGetData()
        }
      })
    },
    fnGetData() {
      //加载列表信息
      let config = {
        params: {
          Query: JSON.stringify(this.Query)
        }
      }

      this.getRequest('Purchase/GetClarifyList', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.tableData = res.data.ClarifyList
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    fnReply(id) {
      //打开回执界面
      let routerData = this.$router.resolve({
        name: 'ClarifyReciept',
        query: {
          id: id
        }
      })
      window.open(routerData.href, '_blank')
    }
  }
}
</script>
<style scoped lang="scss">
#search {
  width: 120px;
}

.searchinput {
  width: 180px;
  margin: 0 60px 0 10px;
}

.right_content {
  margin: 0 10px;
  height: 93%;
  background: #f7f7f7;
}

.right_out {
  width: 98%;
  margin: 0 auto;
}

.welcome {
  height: 40px;
  line-height: 40px;
}

.currentMenu {
  margin: 16px 5px;
}

.btn_wrap {
  .btn {
    color: #6a96bc;
    border: 1px solid #6a96bc;
    border-radius: 5px;
    padding: 2px 18px;
    margin: auto;
  }
}

.link {
  color: #0361b1;
  padding-right: 10px;
}
.statistics_table {
  width: 100%;
  // margin: 5px auto;

  th,
  td {
    text-align: center;
  }

  th {
    background-color: rgba(243, 251, 255, 1);
    color: #0179bd;
    font-weight: 700;
  }
}
</style>